import {
  ORDER_METHODS,
  SMART_PRICING_MODIFIER_TYPE,
  SMART_PRICING_RESOURCE_TYPE,
} from '../../../../../services/exports/Constants';

export default {
  title: {
    [SMART_PRICING_RESOURCE_TYPE.company]: '{{name}} globalna reguła inteligentnych cen',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: '{{name}} główna reguła inteligentnych cen',
    [SMART_PRICING_RESOURCE_TYPE.menu]: '{{name}} reguła inteligentnych cen menu',
    [SMART_PRICING_RESOURCE_TYPE.category]: '{{name}} reguła inteligentnych cen kategorii',
    [SMART_PRICING_RESOURCE_TYPE.product]: '{{name}} reguła inteligentnych cen produktu',
    [SMART_PRICING_RESOURCE_TYPE.modifier_group]: '{{name}} reguła inteligentnych cen grupy modyfikatorów',
    [SMART_PRICING_RESOURCE_TYPE.modifier]: '{{name}} reguła inteligentnych cen modyfikatora',
  },
  labels: {
    new: 'Nowy',
    base_price: '{{name}} cena bazowa: {{value}}',
  },
  form: {
    resource: {
      [SMART_PRICING_RESOURCE_TYPE.menu]: 'Menu',
      [SMART_PRICING_RESOURCE_TYPE.category]: 'Kategoria',
      [SMART_PRICING_RESOURCE_TYPE.product]: 'Produkt',
      [SMART_PRICING_RESOURCE_TYPE.modifier_group]: 'Grupa modyfikatorów',
      [SMART_PRICING_RESOURCE_TYPE.modifier]: 'Modyfikator',
      placeholder: 'Wybierz {{resource}}',
    },
    order_methods: {
      label: 'Metody zamówienia',
      placeholder: 'Wybierz metody zamówienia, do których reguła jest stosowana',
      options: {
        [ORDER_METHODS.pickup]: 'Odbiór',
        [ORDER_METHODS.delivery]: 'Dostawa',
        [ORDER_METHODS.room_service]: 'Obsługa pokoju/stolika',
      },
    },
    modifier_type: {
      label: 'Typ modyfikatora ceny',
      placeholder: 'Wybierz typ modyfikatora ceny',
      disabled_tooltip:
        'Wartość bezwzględna jest niedostępna dla reguł całego menu, ponieważ nadpisałaby cenę każdego produktu.',
      tooltip: {
        title: 'Typ modyfikatora określa sposób modyfikacji cen',
        description: {
          [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Bezwzględny: zastępuje cenę zasobu podaną wartością modyfikatora',
          [SMART_PRICING_MODIFIER_TYPE.percentage]:
            'Procentowy: dodaje/odejmuje podaną procentową wartość modyfikatora od ceny bazowej zasobu w zależności od znaku wartości',
          [SMART_PRICING_MODIFIER_TYPE.fixed_value]:
            'Stała wartość: dodaje/odejmuje podaną stałą wartość modyfikatora od ceny bazowej w zależności od znaku wartości',
        },
      },
      options: {
        [SMART_PRICING_MODIFIER_TYPE.absolute]: 'Bezwzględny',
        [SMART_PRICING_MODIFIER_TYPE.percentage]: 'Procentowy',
        [SMART_PRICING_MODIFIER_TYPE.fixed_value]: 'Stała wartość',
      },
    },
    modifier_value: {
      label: 'Wartość modyfikatora ceny',
    },
    round: {
      label: 'Zaokrąglij cenę wynikową',
      tooltip:
        'Zaokrągla cenę wynikową w górę do 10 (np. 14,91; 14,93; 14,99 staje się 15,00). Przydatne głównie dla reguł procentowych',
    },
    is_visible: {
      label: 'Pokaż klientowi jako ofertę',
    },
    name: {
      label: 'Nazwa',
      placeholder: 'Wprowadź przyjazną dla klienta nazwę',
      default: '{{value}} taniej na {{resource}}',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
